import React, { useState } from 'react';
import {
  FaWhatsapp,
  FaLinkedin,
  FaFacebook,
  FaEnvelope,
  FaMicrosoft,
  FaRegCopy,
  FaTimes
} from 'react-icons/fa';
import './SharePopup.css'; 

const ShareModal = ({ onClose, shareUrl }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 1400);
  };

  
  const whatsappURL = `https://api.whatsapp.com/send?text=${encodeURIComponent(shareUrl)}`;
  const facebookURL = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
  const linkedinURL = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`;
  const emailURL = `mailto:?subject=Je veux partager une mission avec vous&body=${encodeURIComponent(shareUrl)}`;
  const teamsURL = `https://teams.microsoft.com/l/message/19:general?message=${encodeURIComponent(shareUrl)}`;

  return (
    <div className="share-modal-overlay">
      <div className="share-modal-container">
        <button className="share-modal-close-btn" onClick={onClose}><FaTimes /></button>
        <h3 className="share-modal-title">Partager</h3>
        <div className="share-modal-icons">
          <a href={whatsappURL} target="_blank" rel="noopener noreferrer">
            <FaWhatsapp className="share-modal-icon share-modal-whatsapp" title="WhatsApp" />
          </a>
          <a href={facebookURL} target="_blank" rel="noopener noreferrer">
            <FaFacebook className="share-modal-icon share-modal-facebook" title="Facebook" />
          </a>
          <a href={linkedinURL} target="_blank" rel="noopener noreferrer">
            <FaLinkedin className="share-modal-icon share-modal-linkedin" title="LinkedIn" />
          </a>
          <a href={teamsURL} target="_blank" rel="noopener noreferrer">
            <FaMicrosoft className="share-modal-icon share-modal-teams" title="Teams" />
          </a>
          <a href={emailURL} target="_blank" rel="noopener noreferrer">
            <FaEnvelope className="share-modal-icon share-modal-email" title="E-mail" />
          </a>
        </div>
        <div className="share-modal-link-row">
          <input
            type="text"
            className="share-modal-input"
            value={shareUrl}
            readOnly
          />
          <button className="share-modal-copy-btn" onClick={handleCopy}>
            <FaRegCopy /> Copier
          </button>
        </div>
        {copied && (
          <div className="share-modal-feedback">
            Lien copié&nbsp;!
          </div>
        )}
      </div>
    </div>
  );
};

export default ShareModal;
